import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _merge from "lodash/merge.js";
import { useMemo } from "react";
import Title from "../../../../../base/text/title/index.js";
import { genKey } from "../../../../../../helpers/keys.js";
import useTabsCarouselProduct from "../../hooks/useTabsCarouselProduct.js";
import MessageError from "./message-error/index.js";
import * as S from "./styled.js";
import TabProduct from "./tab-product/index.js";
import TabTitle from "./tab-title/index.js";
const TabsCarouselProductCardDesktop = ({ props  })=>{
    const { title , subtitle , config , items =[] , link , isFlat , getTabsProducts , defaultImage  } = props ?? {};
    const { literals  } = config ?? {};
    const { selectedTab , dataTab =[] , tabLoaded , onClickTap  } = useTabsCarouselProduct(items, config, getTabsProducts);
    const finalTabs = useMemo(()=>dataTab.map((item, index)=>{
            const itemConfig = item?.config;
            if (index === 0) {
                const firstTabLink = _merge(item.link, link);
                _merge(item, {
                    link: firstTabLink
                });
            }
            if (item.error?.error) return {
                index,
                label: /*#__PURE__*/ _jsx(TabTitle, {
                    title: item.title,
                    isDeal: item.isDeal
                }, genKey(`${item.title}TabProductTitle`)),
                element: /*#__PURE__*/ _jsx(MessageError, {
                    error: item.error,
                    literals: literals
                })
            };
            return {
                index,
                label: /*#__PURE__*/ _jsx(TabTitle, {
                    title: item.title,
                    isDeal: item.isDeal
                }, genKey(`${item.title}${index}TabProductTitle`)),
                element: /*#__PURE__*/ _jsx(TabProduct, {
                    searcher: item?.searcher,
                    tab: item,
                    config: {
                        ...config,
                        ...itemConfig
                    },
                    isLoading: !tabLoaded[index],
                    isFlat: isFlat,
                    defaultImage: defaultImage
                }, genKey(`${JSON.stringify(item)}${index}TabProductFinal`))
            };
        }), [
        dataTab,
        literals,
        config,
        tabLoaded,
        isFlat,
        defaultImage,
        link
    ]);
    return /*#__PURE__*/ _jsxs(S.CarouselProduct, {
        "data-testid": "TabsCarouselProductCard",
        children: [
            title && /*#__PURE__*/ _jsx(Title, {
                title: title,
                subTitle: subtitle,
                link: link
            }),
            finalTabs.length > 1 ? /*#__PURE__*/ _jsx(S.TabsProductBox, {
                $isFlat: isFlat,
                children: /*#__PURE__*/ _jsx(S.Tabs, {
                    selectedTab: selectedTab,
                    onClick: onClickTap,
                    tabs: finalTabs,
                    sliderProps: {
                        className: 'tab-header',
                        wheel: true
                    },
                    $isFlat: isFlat
                })
            }) : /*#__PURE__*/ _jsx(TabProduct, {
                searcher: items[0]?.searcher,
                tab: items[0],
                config: config,
                isFlat: isFlat,
                defaultImage: defaultImage
            })
        ]
    });
};
export default TabsCarouselProductCardDesktop;

//# sourceMappingURL=index.js.map